/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import first from 'lodash/first';
import get from 'lodash/get';
import last from 'lodash/last';
import {
    BELTON_LAKE_ID,
    BLACKWATER_TURKEY_ID,
    BOMBAY_HOOK_ID,
    BOND_SWAMP_NWR_DEER,
    BOND_SWAMP_NWR_TURKEY,
    BOND_SWAMP_NWR_WATERFOWL,
    CAROLINA_SANDHILLS_ID,
    GEORGETOWN_LAKE_ID,
    GEORGETOWN_WATERFOWL_ID,
    HAVASU_NWR_ID,
    HUNTING_LICENSE_NUMBER_LOTTERY_RESTRICTED,
    PIEDMONT_NWR_DEER_ID,
    PIEDMONT_NWR_TURKEY_ID,
    PRIME_HOOK_ID,
    SOMERVILLE_LAKE_ID,
    TENNESSEE_TOMBIGBEE_WATERWAY_ID,
    GEORGETOWN_OTHER_ID,
    OKEFENOKEE_NWR_SUWANNEE_CANAL,
    MATTAMUSKEET_NWR_WATERFOWL,
    MATTAMUSKEET_DISABLED_WATERFOWL,
    MATTAMUSKEET_YOUTH_WATERFOWL,
} from 'ui-permit/src/constants';
import { issuanceStatuses, readRule } from 'ui-permit/src/utils/utilsNew';
import {
    LOTTERY_AWARDED,
    PERMIT_COMPLETE,
    PERMIT_ISSUED,
} from '../constants/shared-constants';

import { getPermitType } from './getPermitType';

export const getClassName = (error, displayError) => {
    if (error && displayError) {
        return 'rec-error';
    }
    return '';
};

export const getPermitTypeField = (
    permit = {},
    huntType = '',
    field = 'name',
    defaultValue
) => get(getPermitType(permit, huntType), field, defaultValue);
export const getPermitTypeName = (permit = {}, huntType = '') =>
    getPermitTypeField(permit, huntType, 'name', huntType);
export const isOpenPermitType = (permit = {}, huntType = '') =>
    getPermitTypeField(permit, huntType, 'open');
export const canSelectDate = (permit = {}, huntType = '') =>
    getPermitTypeField(permit, huntType, 'date_select');

export const getStartAndEndDates = (dates) =>
    [first(dates), last(dates)].map((d, i) =>
        /\//.test(d) ? (i ? last : first)(d.split('/')) : d
    );

export const isIssuedPermit = (reservation) => {
    return (
        reservation.status === issuanceStatuses.get(PERMIT_ISSUED) ||
        reservation.status === issuanceStatuses.get(PERMIT_COMPLETE) ||
        reservation.status === issuanceStatuses.get(LOTTERY_AWARDED)
    );
};

export const isDNRLotteryRestricted = (permitID, permitRules) => {
    if (permitRules != null && permitRules.length > 0) {
        const ruleHuntingLicenseNumberLotteryRestricted = readRule(
            HUNTING_LICENSE_NUMBER_LOTTERY_RESTRICTED,
            permitRules
        );
        return !ruleHuntingLicenseNumberLotteryRestricted.isMissing;
    }

    return [BLACKWATER_TURKEY_ID].includes(permitID); // TODO: this must be removed when migrated Hunting to Rules
};

// TODO: this must be removed when migrated Hunting to Rules
export function isHuntingLicenseNumberVisible(permitID) {
    return ![
        GEORGETOWN_LAKE_ID,
        TENNESSEE_TOMBIGBEE_WATERWAY_ID,
        SOMERVILLE_LAKE_ID,
        HAVASU_NWR_ID,
        GEORGETOWN_WATERFOWL_ID,
        GEORGETOWN_OTHER_ID,
        MATTAMUSKEET_NWR_WATERFOWL,
        MATTAMUSKEET_DISABLED_WATERFOWL,
        MATTAMUSKEET_YOUTH_WATERFOWL,
    ].includes(permitID);
}

export const isDNRFieldRequired = (permitID, permitValidations) => {
    if (permitValidations != null && permitValidations.length > 0) {
        return !!permitValidations.find(
            (permitValidation) =>
                permitValidation.name === 'IsHuntingLicenseNumberRequired' &&
                permitValidation.group === 'PermitRegistration'
        );
    }

    return ![
        PIEDMONT_NWR_DEER_ID,
        PIEDMONT_NWR_TURKEY_ID,
        BOND_SWAMP_NWR_DEER,
        BOND_SWAMP_NWR_TURKEY,
        BOND_SWAMP_NWR_WATERFOWL,
        OKEFENOKEE_NWR_SUWANNEE_CANAL,
    ].includes(permitID); // TODO: this must be removed when migrated Hunting to Validations
};
